import EmailPasswordLogin from './EmailPasswordLogin';

export default EmailPasswordLogin;
